import { render, staticRenderFns } from "./NotOpportunities.vue?vue&type=template&id=49e8f16c&scoped=true&"
import script from "./NotOpportunities.vue?vue&type=script&lang=js&"
export * from "./NotOpportunities.vue?vue&type=script&lang=js&"
import style0 from "./NotOpportunities.vue?vue&type=style&index=0&id=49e8f16c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "49e8f16c",
  null
  
)

export default component.exports